module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp13_2.c25d4882.png";